import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-4 pr-4 pt-3 pb-1 shadow-2 relative bottom-0 bg-white z-3" }
const _hoisted_2 = { class: "flex flex-column gap-1 align-items-end" }
const _hoisted_3 = { class: "app-label-small" }
const _hoisted_4 = {
  class: "font-bold text-default-gray",
  href: "https://support.ubiant.com/contact/",
  target: "_blank"
}
const _hoisted_5 = { class: "app-label-small text-default-gray font-bold" }
const _hoisted_6 = { class: "app-label-small text-default-gray font-bold" }
const _hoisted_7 = { class: "flex justify-content-center mt-3" }
const _hoisted_8 = { class: "app-label-micro text-gray-l1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('commons.contact-us')), 1)
      ]),
      _createVNode(_component_router_link, { to: "/legal-informations" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('top-bar-title.legal-infos')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/rgpd" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('menu-label.rgpd')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('footer.copyright', { year: new Date().getFullYear() })), 1)
    ])
  ]))
}